;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { useQuery } from "@apollo/client/react"
import get from "lodash/get"
import getGroup from "../graphql/queries/getGroup"

export type UseGetGroupArgs = {
  groupId: number | null
  organizationId?: string | number | null
}

export type GroupQueryData = {
  group?: {
    config?: Record<string, unknown> | null
    [key: string]: unknown
  } | null
}

export type UseGetGroupState = {
  loading: boolean
  error: unknown
  group: Record<string, unknown>
  groupConfigObj: Record<string, unknown>
}

export type UseGetGroupActions = {
  getGroupRefetch: () => void
}

export default function useGetGroup({
  groupId,
  organizationId: _organizationId,
}: UseGetGroupArgs): [UseGetGroupState, UseGetGroupActions] {
  const {
    loading: getGroupLoading,
    error: getGroupError,
    data: getGroupData,
    refetch: getGroupRefetch,
  } = useQuery<GroupQueryData>(getGroup, {
    skip: !groupId,
    variables: {
      id: groupId,
    },
    fetchPolicy: "no-cache",
  })
  const groupConfigObj = get(getGroupData, "group.config", {}) as Record<
    string,
    unknown
  >
  const group = get(getGroupData, "group", {}) as Record<string, unknown>

  return [
    {
      loading: getGroupLoading,
      error: getGroupError,
      group: group,
      groupConfigObj,
    },
    { getGroupRefetch },
  ]
}
